import React from "react";
import Layout from "components/layout/Layout";
import PostContainer from "components/post/PostContainer";

const Home = () => {
  return (
    <Layout>
      <PostContainer />
    </Layout>
  );
};

export default Home;
